import { useEffect } from "react"
import PayrollExportPanel from "../../components/construction/PayrollExportPanel"
import { ManagementCompany } from "../../Interfaces"

const companies: ManagementCompany[] = [
  { id: 12, name: "Valley Builders", code: "VAL" },
  { id: 8, name: "Pacific Framing", code: "PFR" },
]

const demoPreview = {
  success: true,
  companyId: 12,
  companyCode: "VAL",
  from: "2026-10-01",
  to: "2026-10-07",
  filename: "VAL_PRDAILY_2026-10-01_2026-10-07.csv",
  rowCount: 2,
  rows: [
    { filetype: "PRDAILY", paydte: "2026-10-02", empnum: 42, jobnum: 2017008, cstcde: 2120, payhrs: 7.5, dscrpt: "ConstructionWalk" },
    { filetype: "PRDAILY", paydte: "2026-10-03", empnum: 43, jobnum: 2017008, cstcde: 2120.5, payhrs: 8, dscrpt: "ConstructionWalk" },
  ],
  warnings: [
    { reason: "still_clocked_in", message: "Ada Lovelace is still clocked in on 2026-10-02." },
  ],
}

/**
 * Unauthenticated fixture for ConstructionWalk dashboard payroll export.
 * /preview/dashboard?product=construction
 */
export default function DashboardPreview() {
  const params = new URLSearchParams(window.location.search)
  const single = params.get("single") === "1"
  const emptyPreview = params.get("emptyPreview") === "1"

  useEffect(() => {
    document.documentElement.classList.add("construction-walk")
  }, [])

  return (
    <div className="min-h-screen p-4 md:p-8 bg-secondary-extra-light">
      <PayrollExportPanel
        companies={single ? companies.slice(0, 1) : companies}
        allowCompanySelect={!single}
        companyId={12}
        initialPreview={emptyPreview ? null : demoPreview}
      />
    </div>
  )
}
